import { render, staticRenderFns } from "./WorkplaceRegistration.vue?vue&type=template&id=46c5efd2&scoped=true&"
import script from "./WorkplaceRegistration.vue?vue&type=script&lang=js&"
export * from "./WorkplaceRegistration.vue?vue&type=script&lang=js&"
import style0 from "./WorkplaceRegistration.vue?vue&type=style&index=0&id=46c5efd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c5efd2",
  null
  
)

export default component.exports